import React, { useState } from "react";
import PaymentsTable from "./PaymentsTable";
import PaymentDetails from "./PaymentDetails";
function PaymentManagement() {
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const [selectedPaymentDetails, setSelectedPaymentDetails] = useState(null);

  const handleViewPayment = (payment) => {
    setSelectedPaymentId(payment.payment_id);
    setSelectedPaymentDetails(payment);
    setShowPaymentDetails(true);
  };

  const handleCloseDetails = () => {
    setShowPaymentDetails(false);
    setSelectedPaymentId(null);
  };

  const handlePaymentUpdated = () => {
    setShowPaymentDetails(false);
  };

  return (
    <div>
      <PaymentsTable onViewDetails={handleViewPayment} />

      <PaymentDetails
        visible={showPaymentDetails}
        paymentId={selectedPaymentId}
        selectedPaymentDetails={selectedPaymentDetails}
        onClose={handleCloseDetails}
        onPaymentUpdate={handlePaymentUpdated}
      />
    </div>
  );
}
export default PaymentManagement;
